import React from 'react';
import classnames from 'classnames';
import ArtStageArrowLIcon from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArtStageArrowRIcon from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import s from './DeviationSlideshow.scss';

interface Props {
  currentIndex: number;
  itemCount: number;
  onPrevClick(): void;
  onNextClick(): void;
}

const Controls: React.FC<Props> = ({
  currentIndex,
  itemCount,
  onPrevClick,
  onNextClick,
}) => (
  <nav className={s['controls']}>
    {currentIndex > 0 && (
      <button
        className={classnames(s['controls-button'], s['prev'])}
        onClick={onPrevClick}
      >
        <ArtStageArrowLIcon />
      </button>
    )}
    {currentIndex + 1 < itemCount && (
      <button
        className={classnames(s['controls-button'], s['next'])}
        onClick={onNextClick}
      >
        <ArtStageArrowRIcon />
      </button>
    )}
  </nav>
);

export default React.memo(Controls);
